import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBIcon, MDBRow } from "mdb-react-ui-kit";
import Footer from "./Footer";

export default function Mapa() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
});
  return (
    <div>
      <MDBContainer className="mt-5 mb-5">
        <MDBRow>
          <MDBCol md={6} >
            
          <h1>
            Donuts Paradise Map 
            <MDBIcon fas icon="map-marked-alt" className="ms-2"/>
          </h1>
            <MDBCard className="P-2">
              <MDBCardTitle className="fs-5 p-2 fw-blod">20 de Julio </MDBCardTitle>
              <MDBCardBody>
                <MDBRow>
                  <MDBCol>
                  Cartagena - barrio 20 de julio, sector villa ortega CL 3 E#56 I-13
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
            <MDBCard className="p-2">
              <MDBCardTitle>Horarios</MDBCardTitle>
              <MDBCardBody>
                <MDBRow>
                  <MDBCol>Lunes</MDBCol>
                  <MDBCol>9 a.m. - 5 p.m.</MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol>Martes</MDBCol>
                  <MDBCol>9 a.m. - 5 p.m.</MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol>Miércoles</MDBCol>
                  <MDBCol>9 a.m. - 5 p.m.</MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol>Jueves</MDBCol>
                  <MDBCol>9 a.m. - 5 p.m.</MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol>Viernes</MDBCol>
                  <MDBCol>9 a.m. - 5 p.m.</MDBCol>
                </MDBRow >
                <MDBRow>
                  <MDBCol>Sábado</MDBCol>
                  <MDBCol>9 a.m. - 5 p.m.</MDBCol>
                </MDBRow >
                <MDBRow>
                  <MDBCol>Domingos</MDBCol>
                  <MDBCol>Cerrado</MDBCol>
                </MDBRow >
              </MDBCardBody>
              <div className="text-center">
                * El horario podría cambiar en días festivos
              </div>
            </MDBCard>
          </MDBCol >
          <MDBCol md={6}>
            <div className="ratio ratio-1x1">
              <iframe
              className="square rounded border border-4 border-secondary"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15698.277778432008!2d-75.5004616!3d10.3762693!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef62791c6e3ca09%3A0x10b258b418910ced!2sdonuts%20paradise!5e0!3m2!1ses-419!2sco!4v1706381886077!5m2!1ses-419!2sco"
                title="YouTube video"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </MDBCol>
        </MDBRow >
      </MDBContainer >

      <Footer />
    </div >
  );
}